<template>
  <div id="map" class="map"></div>
</template>
<script>
import storage from 'store'
import { LonLat } from '@/store/mutation-types'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import * as olProj from 'ol/proj'
import { defaults } from 'ol/interaction'
import { unByKey } from 'ol/Observable'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import LineString from 'ol/geom/LineString'
import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
var map
export default {
  data () {
    return {
      addOrUpdateVisible: true,
      clickTypeList: [],
      childValue: []
    }
  },
  mounted () {
    this.initMap()
  },
  methods: {
    handleCancel (e) {
      this.$parent.showMap = false
    },
    handleOk (e) {
      this.$parent.showMap = false
    },
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      console.log('storage', storage.get(LonLat))
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      map = new Map({
        view: new View({
          center: [Number(storage.get(LonLat)[0]), Number(storage.get(LonLat)[1])], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 13.5, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        target: 'map' // 地图容器id
      })
      const road_layer = new TileLayer({
        name: '底图',
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      // map.on("click",function(e){
      //     console.log(e.coordinate)
      // });
      map.addLayer(road_layer)
      var cql = `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}'`
      var layer = {
        dataSource: 'smart_water:gis_pipe_line',
        id: '1429987144120979457',
        workspace: 'smart_water'
      }
      this.wmsLayers(layer, cql, true)
      this.redLine()
    },
    searchLines (start, end) {
      // search_gis_pipe_line 管线图层  class_no 分类编码
      var cql =
        `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}' and` +
        ` (start_class_no = '${start}' and end_class_no = '${end}')`
      this.queryWmsLayers('smart_water', `smart_water:search_gis_pipe_line`, cql)
    },
    queryWmsLayers (workspace, layerName, cql) {
      this.removeLayerByName('condition_query_wms_layer')
      const params = { LAYERS: layerName, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/${workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        name: 'condition_query_wms_layer',
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 99999
      })
      map.addLayer(wmsLayer)
    },
    removeLayerByName (name) {
      const allLayers = map.getLayers()
      var list = allLayers.array_
      console.log('allLayers', allLayers)
      console.log('list', list)
      for (let index = 0; index < list.length; index++) {
        const layer = list[index]
        if (layer.values_.name === name) {
          console.log('删除涂层', layer)
          map.removeLayer(layer)
          // index--
        }
      }
    },
    // 管线图层
    wmsLayers (layer, cql = '', isVisible = true) {
      this.removeLayerByName(layer.id)
      const params = { LAYERS: layer.dataSource, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/${layer.workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        name: layer.id,
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 1
      })
      wmsLayer.setVisible(isVisible)
      map.addLayer(wmsLayer)
      this.clickWMS(wmsSource, layer, wmsLayer)
    },
    // 点击显示的红色线
    redLine () {
      // 红色线
      this.redSource = new VectorSource()
      this.redVector = new VectorLayer({
        source: this.redSource,
        zIndex: 9999999,
        style: new Style({
          fill: new Fill({
            color: '#FF0000'
          }),
          stroke: new Stroke({
            width: 3,
            color: [255, 0, 0, 1]
          })
        })
      })
      map.addLayer(this.redVector)
    },
    // WMS点击事件
    clickWMS (wmsSource, layer, wmsLayer) {
      // if (Object.keys(this.clickTypeList).indexOf(layer.id) === -1){
      // debugger
      unByKey(this.clickTypeList[layer.id])
      console.log('this.clickTypeList', this.clickTypeList)
      const that = this
      this.clickTypeList[layer.id] = map.on(
        'click',
        function (e) {
          const url = wmsSource.getFeatureInfoUrl(e.coordinate, map.getView().getResolution(), 'EPSG:4326', {
            INFO_FORMAT: 'application/json'
          })
          // 判断是否有要素，一般wms返回的是false没有要素，所以wms的功能代码在else里
          if (map.hasFeatureAtPixel(e.coordinate)) {
            if (url) {
              fetch(url)
                .then((response) => {
                  return response.json()
                })
                .then((data) => { })
            }
          } else {
            if (url) {
              fetch(url)
                .then((response) => {
                  return response.json()
                })
                .then((data) => {
                  if (data.features.length != 0) {
                    if (wmsLayer.values_.visible) {
                      const layer_id = data.features[0].id.split('.')[0]
                      that.layer_numberId = data.features[0].id.split('.')[1]
                      that.redSource.clear()
                      that.childValue = data.features
                      that.$emit('childByValue', that.childValue)
                      console.log('asdasdasd', data.features)
                      var lightFeature = new Feature({
                        geometry: new LineString(data.features[0].geometry.coordinates)
                      })
                      that.redSource.addFeature(lightFeature)
                    }
                  }
                })
            }
          }
        }
      )
      // }
    }
  }
}
</script>
<style scoped>
.map {
  width: 900px;
  height: 450px;
  position: relative;
}
</style>
